import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, PenTool, CheckSquare, Mail } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function OfferBonuses() {
  const bonuses = [{
    icon: <PenTool className="w-6 h-6" data-id="element-169" />,
    title: 'BONUS #1: Plantillas de Gratitud',
    desc: 'Un set de herramientas para integrar el hábito de la gratitud en tu vida diaria (21 días).'
  }, {
    icon: <CheckSquare className="w-6 h-6" data-id="element-170" />,
    title: 'BONUS #2: Checklist de 21 días - "Sanando tu Niña Interior"',
    desc: 'Un proceso guiado para reconectar con tu historia emocional y transformar tu amor propio.'
  }, {
    icon: <Mail className="w-6 h-6" data-id="element-171" />,
    title: 'BONUS #3: Plantillas de Cartas Terapéuticas',
    desc: 'Guías para escribir cartas que te ayuden a cerrar ciclos, liberar emociones y sanar relaciones.'
  }];
  return <section className="bg-brown-dark text-cream-light py-20 md:py-32 relative overflow-hidden" data-id="element-172">
      {/* Background texture */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")"
    }} data-id="element-173"></div>

      <div className="max-w-5xl mx-auto px-6 relative z-10" data-id="element-174">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 space-y-4" data-id="element-175">
          <h2 className="text-3xl md:text-5xl font-playfair font-bold text-gold-main" data-id="element-176">
            Hoy no solo obtienes el ebook completo.
          </h2>
          <p className="font-lora text-xl text-cream-dark/80" data-id="element-177">
            También recibirás 3 bonos exclusivos incluidos sin costo adicional.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start" data-id="element-178">
          {/* Main Product Card */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="lg:col-span-5 bg-cream-light text-brown-dark p-8 rounded-sm shadow-2xl" data-id="element-179">
            <div className="flex items-center gap-3 text-gold-dark mb-6 border-b border-gold-main/20 pb-4" data-id="element-180">
              <BookOpen className="w-8 h-8" data-id="element-181" />
              <h3 className="text-2xl font-playfair font-bold" data-id="element-182">
                El eBook Completo
              </h3>
            </div>
            <ul className="space-y-3 font-lora text-sm" data-id="element-183">
              <li className="flex items-start gap-2" data-id="element-184">
                <span className="text-gold-main mt-0.5" data-id="element-185">✓</span>
                <span data-id="element-186">Más de 200 páginas de contenido profundo</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-187">
                <span className="text-gold-main mt-0.5" data-id="element-188">✓</span>
                <span data-id="element-189">Ceremonias de Unión</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-190">
                <span className="text-gold-main mt-0.5" data-id="element-191">✓</span>
                <span data-id="element-192">
                  Ceremonias de Bienvenida al mundo y bendición de nombre
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-193">
                <span className="text-gold-main mt-0.5" data-id="element-194">✓</span>
                <span data-id="element-195">Ritual de cumpleaños</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-196">
                <span className="text-gold-main mt-0.5" data-id="element-197">✓</span>
                <span data-id="element-198">Ritual para Transiciones difíciles</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-199">
                <span className="text-gold-main mt-0.5" data-id="element-200">✓</span>
                <span data-id="element-201">Ritual para Cierre de ciclos</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-202">
                <span className="text-gold-main mt-0.5" data-id="element-203">✓</span>
                <span data-id="element-204">
                  Ritual para Cierre de año e inicio de uno nuevo (con mapa de
                  sueños)
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-205">
                <span className="text-gold-main mt-0.5" data-id="element-206">✓</span>
                <span data-id="element-207">Ritual para Atraer más abundancia</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-208">
                <span className="text-gold-main mt-0.5" data-id="element-209">✓</span>
                <span data-id="element-210">Ritual para Desarrollar tu intuición</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-211">
                <span className="text-gold-main mt-0.5" data-id="element-212">✓</span>
                <span data-id="element-213">Ritual para Construir y potenciar tu amor propio</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-214">
                <span className="text-gold-main mt-0.5" data-id="element-215">✓</span>
                <span data-id="element-216">Rituales para atravesar un duelo</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-217">
                <span className="text-gold-main mt-0.5" data-id="element-218">✓</span>
                <span data-id="element-219">Rituales de pareja para fortalecer el vínculo</span>
              </li>
            </ul>
          </motion.div>

          {/* Bonuses List */}
          <div className="lg:col-span-7 space-y-4" data-id="element-220">
            {bonuses.map((bonus, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.15
          }} className="bg-brown-light/30 border border-gold-main/20 p-6 rounded-sm flex gap-4 items-start" data-id="element-221">
                <div className="bg-gold-main/20 p-3 rounded-sm text-gold-main flex-shrink-0" data-id="element-222">
                  {bonus.icon}
                </div>
                <div data-id="element-223">
                  <h4 className="text-xl font-playfair font-semibold text-gold-main mb-2" data-id="element-224">
                    {bonus.title}
                  </h4>
                  <p className="font-lora text-cream-dark/80" data-id="element-225">{bonus.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </div>

        {/* Price & CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-20 text-center bg-cream-light text-brown-dark p-10 md:p-16 rounded-sm max-w-3xl mx-auto shadow-2xl" data-id="element-226">
          <h3 className="text-2xl font-playfair font-bold mb-6" data-id="element-227">
            Valor total del paquete
          </h3>

          <div className="flex justify-center items-center gap-4 mb-8 font-lora text-lg" data-id="element-228">
            <span className="line-through text-brown-light/60" data-id="element-229">
              Valor real: $47+
            </span>
            <span className="text-gold-main" data-id="element-230">→</span>
            <span className="font-bold" data-id="element-231">Hoy disponible por:</span>
          </div>

          <div className="text-6xl md:text-7xl font-playfair font-bold text-gold-dark mb-4" data-id="element-232">
            $7.99 <span className="text-2xl text-brown-light" data-id="element-233">USD</span>
          </div>

          <p className="font-lora text-brown-light mb-8" data-id="element-234">
            Pago único · Acceso inmediato
          </p>

          <CTAButton className="w-full sm:w-auto px-12 py-5 text-xl" data-id="element-235">
            Quiero acceder ahora
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}